<template>
  <div>

    <Row :gutter="10">
      <Col span="4">
        <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter: dealerCityFilter}"
                     :debounce="500" :skip="skip.dealerSkip">
          <template slot-scope="{ result: { loading, error, data } }">
            <div v-if="loading"> Loading...</div>
            <div v-else-if="error"> Error Occured. {{error}}</div>
            <div v-else>
              <AutoComplete placeholder="Order City" v-model="dealerCity" :clearable="true" element-id="client_city"
                            @on-clear="onClearCity('clientCity')" @on-search="onSearchCity($event, 'clientCity')">
                <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.city:[]">
                  <div class="ivu-select-item-div" @click="onSelectCity(cityObj.city, 'clientCity')">{{cityObj.city}}</div>
                </Option>
              </AutoComplete>
            </div>
          </template>
        </ApolloQuery>
      </Col>
      <Col span="4">
        <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter: pickupCityFilter}"
                     :debounce="500" :skip="skip.pickupSkip">
          <template slot-scope="{ result: { loading, error, data } }">
            <div v-if="loading"> Loading...</div>
            <div v-else-if="error"> Error Occured. {{error}}</div>
            <div v-else>
              <AutoComplete placeholder="Pickup City" v-model="pickupCity" :clearable="true" element-id="pickup_city"
                            @on-clear="onClearCity('pickupCity')" @on-search="onSearchCity($event, 'pickupCity')">
                <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.city:[]">
                  <div class="ivu-select-item-div" @click="onSelectCity(cityObj.city, 'pickupCity')">{{cityObj.city}}</div>
                </Option>
              </AutoComplete>
            </div>
          </template>
        </ApolloQuery>
      </Col>
      <Col span="4">
        <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter: droppingCityFilter}"
                     :debounce="500" :skip="skip.dropSkip">
          <template slot-scope="{ result: { loading, error, data } }">
            <div v-if="loading"> Loading...</div>
            <div v-else-if="error"> Error Occured. {{error}}</div>
            <div v-else>
              <AutoComplete placeholder="Drop City" v-model="droppingCity" :clearable="true" element-id="drop_city"
                            @on-clear="onClearCity('dropCity')" @on-search="onSearchCity($event, 'dropCity')">
                <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.city:[]">
                  <div class="ivu-select-item-div" @click="onSelectCity(cityObj.city, 'dropCity')">{{cityObj.city}}</div>
                </Option>
              </AutoComplete>
            </div>
          </template>
        </ApolloQuery>
      </Col>
      <Button style="float: right; margin:0px 0px 0px 12px" @click="startAddingOrder">Add Order</Button>
      <DatePicker v-model="filterDate" type="daterange" :options="dateOptions" placeholder="Select date" :clearable="false"
                  format="dd/MM/yyyy" class="filterInput" style="width: 260px; float: right" @on-change="onChangeDate"></DatePicker>
      <Col span="8" style="margin-top: 10px;">
        <Select v-model="selectedAreaGroups" multiple filterable placeholder="Area Group" >
          <Option v-for="ag in areaGroups" :value="ag.name" :label="ag.name" :key="ag.id"/>
        </Select>
      </Col>
    </Row>

    <Tabs v-model="screen" type="card" style="margin-top: 20px" @on-click="enableTab">
      <TabPane :label="'Pickup Order Process ('+pickup_orders.length+')'" name="pickup"></TabPane>
      <TabPane :label="'Delivery Order Process ('+delivery_orders.length+')'" name="delivery"></TabPane>
      <TabPane :label="'Open Order Process ('+open_orders.length+')'" name="open"></TabPane>
    </Tabs>

    <Button style="position: absolute;right: 120px;top: 60px;" type="success" @click="exportOrdersCSV">Export CSV</Button>
    <Button style="position: absolute;right: 18px;top: 60px;" type="success" @click="exportOrdersPDF">Export PDF</Button>
    <div v-show="screen === 'pickup'">
      <Row class="align-center">
        <Col span="8" style="float: right">
          <Select v-model="colsToHide.pickup" multiple filterable placeholder="Select Columns to Hide" @on-change="onChangeColsToHide('pickup')">
            <Option v-for="(colset, index) in columns('pickup')" :value="index" :key="index"
                    :label="colset.title.replace(/<br>/g, ' ')"></Option>
          </Select>
        </Col>
        <Col span="16">
          Selected Orders ({{numOfSelectedOrders['pickup']}}/{{pickup_orders.length}}) &nbsp; {{evaluatedWeight['pickup']}}/{{totalWeight['pickup']}} Kg
        </Col>
      </Row>
      <hot-table :settings="pickup_hotSettings" ref="pickup_hotTableComponent" style="margin: 20px 0 0 0">
        <hot-column v-for="(colset, index) in columns('pickup')" :settings="colset" :key="index">
          <component hot-editor v-bind:is="colset.component"
                     v-bind="{[excludeComponents.includes(colset.component)?'':'hot-renderer']: true}"></component>
        </hot-column>
      </hot-table>
    </div>

    <div v-show="screen === 'delivery'" v-if="enableScreen.delivery">
      <Row>
        <Col span="8" style="float: right">
          <Select v-model="colsToHide.delivery" multiple filterable placeholder="Select Columns to Hide" @on-change="onChangeColsToHide('delivery')">
            <Option v-for="(colset, index) in columns('delivery')" :value="index" :key="index"
                    :label="colset.title.replace(/<br>/g, ' ')"></Option>
          </Select>
        </Col>
        <Col span="16">
          Selected Orders ({{numOfSelectedOrders['delivery']}}/{{delivery_orders.length}}) &nbsp; {{evaluatedWeight['delivery']}}/{{totalWeight['delivery']}} Kg
        </Col>
      </Row>
      <hot-table :settings="delivery_hotSettings" ref="delivery_hotTableComponent" style="margin: 20px 0 0 0">
        <hot-column v-for="(colset, index) in columns('delivery')" :settings="colset" :key="index">
          <component hot-editor v-bind:is="colset.component"
                     v-bind="{[excludeComponents.includes(colset.component)?'':'hot-renderer']: true}"></component>
        </hot-column>
      </hot-table>
    </div>

    <div v-show="screen === 'open'" v-if="enableScreen.open">
      <Row>
        <Col span="8" style="float: right">
          <Select v-model="colsToHide.open" multiple filterable placeholder="Select Columns to Hide" @on-change="onChangeColsToHide('open')">
            <Option v-for="(colset, index) in columns('open')" :value="index" :key="index" :label="colset.title.replace(/<br>/g, ' ')"></Option>
          </Select>
        </Col>
        <Col span="16">
          Selected Orders ({{numOfSelectedOrders['open']}}/{{open_orders.length}}) &nbsp; {{evaluatedWeight['open']}}/{{totalWeight['open']}} Kg
        </Col>
      </Row>
      <hot-table :settings="open_hotSettings" ref="open_hotTableComponent" style="margin: 20px 0 0 0">
        <hot-column v-for="(colset, index) in columns('open')" :settings="colset" :key="index">
          <component hot-editor v-bind:is="colset.component"
                     v-bind="{[excludeComponents.includes(colset.component)?'':'hot-renderer']: true}"></component>
        </hot-column>
      </hot-table>
    </div>

    <Modal v-model="confirmDialog" title="Confirmation" draggable>
      <p>Are You sure want to update field  {{confirmObj.col?columns()[confirmObj.col].title:''}}?</p>
      <p>from {{confirmObj.oldValue}}</p>
      <p>to {{confirmObj.newValue}}</p>
      <div slot="footer">
        <Button type="primary" style="font-weight: bolder" :loading="updateRecord_loader"
                @click="updateRecord(confirmObj.row, confirmObj.prop, confirmObj.newValue)">
          <span v-if="!updateRecord_loader">OK</span>
          <span v-else>Loading...</span>
        </Button>
        <Button style="background: #999999; color: white;font-weight: bolder" @click="revertChange(confirmObj.row, confirmObj.prop, confirmObj.oldValue)">
          CANCEL</Button>
      </div>
    </Modal>

    <place-order-drawer ref="place-order-form"></place-order-drawer>
    <manage-order :orderId="orderId" ref="manage-order-page" :viewPath="viewPath"></manage-order>
    <LRForm :formDialog.sync="lrFormDialog" :orderId="lrOrderId" :lrId.sync="lrId"/>

  </div>
</template>

<script>
  import {
    generate_PICKUP_PROCESS_ORDERS_CITYWISE,
    generate_DELIVERY_PROCESS_ORDERS_CITYWISE, generate_OPEN_PROCESS_ORDERS_CITYWISE
  }
    from "../../graphql/subscription/Orders"
  import {SEARCH_CITY2} from "../../graphql/queries/territories"
  import {Constants, TableSettings} from "../../Constants/Constant"
  import { HotTable, HotColumn } from '@handsontable/vue'
  import {
    actionRenderer,
    noteRenderer,
    carryBillRenderer,
    ewayBillRenderer,
    localVehicleRenderer,
    transportVehicleRenderer,
    pickupDateRenderer,
    orderNumberRenderer,
    orderDetailsRenderer,
    pickupAreaGroupRenderer,
    dropAreaGroupRenderer, createdUpdatedOnRenderer, clientNameRenderer, lrNumberRenderer
  } from "./RendererFunctions"
import Handsontable from 'handsontable'
import {hotSettingsExcelOrders, roughtOfOrder, dateOptions} from "./Settings"
import ActionPopup from './ActionPopup'
import EwayBillPopup from "./EwayBillPopup"
import QuantityPopup from "./QuantityPopup"
import LocalVehiclePopup from "./LocalVehiclePopup"
import TransportVehiclePopup from "./TransportVehiclePopup"
import PickupPartyPopup from "./PickupPartyPopup"
import DropPartyPopup from "./DropPartyPopup"
import ManageOrder from "../Manage Order/ManageOrder"
import {ADD_ORDER_NOTE} from "../../graphql/mutations/orders"
import {generate_UPDATE_ORDER_DATA} from '../../graphql/mutations/orders'
import moment from 'moment'
import PlaceOrderDrawer from "../PlaceOrderDrawer";
import {bus} from "../../main";
import jsPDF from 'jspdf';
import {GET_ALL_AREAGROUPS} from "../../graphql/queries/areaGroup";
import LRForm from "../LR/LRForm";
import {isLREditable} from "../LR/Settings";



export default {
    name: "ExcelFormattedOrders",
    components: {
      LRForm, ManageOrder, DropPartyPopup, PickupPartyPopup, TransportVehiclePopup, LocalVehiclePopup, QuantityPopup, EwayBillPopup,
      ActionPopup, HotTable, HotColumn, PlaceOrderDrawer},
    props:['globalSearch'],
    provide() {
      return {
        getManageOrderDrawer: () => this.manageOrderDrawer,
        setManageOrderDrawer: (data) => { this.manageOrderDrawer = data },
        getOrder: () => this.order,
        closeAssignVehicleDialog: (data) => { },
      }
    },
    apollo: {
      pickup_orders: {
        query() { return generate_PICKUP_PROCESS_ORDERS_CITYWISE() },
        skip(){return this.skipQuery.pickup},
        fetchPolicy: 'network-only',
        variables () {
          return {
            startDate: this.startDate,
            endDate: this.endDate,
            clientCity: this.selectedDealerCity,
            pickupCity: this.selectedPickupCity,
            dropCity: this.selectedDroppingCity,
            searchFilter: '%' + this.globalSearch + '%',
            lrName: { lrName: this.globalSearch },
            selectedAreaGroups: this.selectedAreaGroups.length?this.selectedAreaGroups:null
          }
        },
        subscribeToMore: {
          document() {return generate_PICKUP_PROCESS_ORDERS_CITYWISE('subscription')},
          skip(){return this.skipQuery.pickup},
          variables () {
            return {
              startDate: this.startDate,
              endDate: this.endDate,
              clientCity: this.selectedDealerCity,
              pickupCity: this.selectedPickupCity,
              dropCity: this.selectedDroppingCity,
              searchFilter: '%' + this.globalSearch + '%',
              lrName: { lrName: this.globalSearch },
              selectedAreaGroups: this.selectedAreaGroups.length?this.selectedAreaGroups:null
            }
          },
          updateQuery: function (previousQueryResult, {subscriptionData:{data}}) {
            console.log('Excel Pickup Orders Subscribed')
            this.pickup_orders = data.pickup_orders
            bus.$emit('refreshRecord', 'refresh')
            this.prepareSheetData(data.pickup_orders, 'pickup')
          },
        },
        result ({ data }) {
          this.pickup_orders = data.pickup_orders
          this.prepareSheetData(data.pickup_orders, 'pickup')
        },
      },
      delivery_orders: {
        query() { return generate_DELIVERY_PROCESS_ORDERS_CITYWISE() },
        skip(){return this.skipQuery.delivery},
        fetchPolicy: 'network-only',
        variables () {
          return {
            startDate: this.startDate,
            endDate: this.endDate,
            clientCity: this.selectedDealerCity,
            pickupCity: this.selectedPickupCity,
            dropCity: this.selectedDroppingCity,
            searchFilter: '%' + this.globalSearch + '%',
            lrName: { lrName: this.globalSearch },
            selectedAreaGroups: this.selectedAreaGroups.length?this.selectedAreaGroups:null
          }
        },
        subscribeToMore: {
          document() {return generate_DELIVERY_PROCESS_ORDERS_CITYWISE('subscription')},
          skip(){return this.skipQuery.delivery},
          variables () {
            return {
              startDate: this.startDate,
              endDate: this.endDate,
              clientCity: this.selectedDealerCity,
              pickupCity: this.selectedPickupCity,
              dropCity: this.selectedDroppingCity,
              searchFilter: '%' + this.globalSearch + '%',
              lrName: { lrName: this.globalSearch },
              selectedAreaGroups: this.selectedAreaGroups.length?this.selectedAreaGroups:null
            }
          },
          updateQuery: function (previousQueryResult, {subscriptionData:{data}}) {
            console.log('Excel Delivery Orders Subscribed')
            this.delivery_orders = data.delivery_orders
            this.prepareSheetData(data.delivery_orders, 'delivery')
          },
        },
        result ({ data }) {
          this.delivery_orders = data.delivery_orders
          this.prepareSheetData(data.delivery_orders, 'delivery')
        },
      },
      open_orders: {
        query() { return generate_OPEN_PROCESS_ORDERS_CITYWISE() },
        skip(){return this.skipQuery.open},
        fetchPolicy: 'network-only',
        variables () {
          return {
            startDate: this.startDate,
            endDate: this.endDate,
            clientCity: this.selectedDealerCity,
            pickupCity: this.selectedPickupCity,
            dropCity: this.selectedDroppingCity,
            searchFilter: '%' + this.globalSearch + '%',
            lrName: { lrName: this.globalSearch },
            selectedAreaGroups: this.selectedAreaGroups.length?this.selectedAreaGroups:null
          }
        },
        subscribeToMore: {
          document() {return generate_OPEN_PROCESS_ORDERS_CITYWISE('subscription')},
          skip(){return this.skipQuery.open},
          variables () {
            return {
              startDate: this.startDate,
              endDate: this.endDate,
              clientCity: this.selectedDealerCity,
              pickupCity: this.selectedPickupCity,
              dropCity: this.selectedDroppingCity,
              searchFilter: '%' + this.globalSearch + '%',
              lrName: { lrName: this.globalSearch },
              selectedAreaGroups: this.selectedAreaGroups.length?this.selectedAreaGroups:null
            }
          },
          updateQuery: function (previousQueryResult, {subscriptionData:{data}}) {
            console.log('Excel Open Orders Subscribed')
            this.open_orders = data.open_orders
            this.prepareSheetData(data.open_orders, 'open')
          },
        },
        result ({ data }) {
          this.open_orders = data.open_orders
          this.prepareSheetData(data.open_orders, 'open')
        },
      },
      areaGroups:{ query: GET_ALL_AREAGROUPS }
    },
        data: function () {
            return{
                query_SEARCH_CITY: SEARCH_CITY2,
                elapsedInterval: {pickup:{}, delivery:{}, open:{}},
                screen: 'pickup',
                screenArr: ['pickup', 'delivery', 'open'],
                enableScreen:{delivery: false, open: false},
                excludeComponents: ['ActionPopup', 'PickupPartyPopup', 'DropPartyPopup', 'QuantityPopup','EwayBillPopup', 'LocalVehiclePopup', 'TransportVehiclePopup'],
                orders: [],
                pickup_orders: [],
                delivery_orders: [],
                open_orders: [],
                skipQuery: {pickup:true ,delivery: true, open: true},            //To skip delivery & open orders at initial
                filterDate: [moment().subtract(7, 'days').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
                startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD'),
                dealerCity: '',
                pickupCity: '',
                droppingCity: '',
                skip: {dealerSkip: true, pickupSkip: true, dropSkip: true}, //To Avoid calls at initial
                dealerCityFilter: '%%',
                pickupCityFilter: '%%',
                droppingCityFilter: '%%',
                selectedDealerCity: {"address":[]},
                selectedPickupCity: {"address":[]},
                selectedDroppingCity: {"address":[]},
                dateOptions: dateOptions,
                columns: (screen) => [
                  //table_key_intermediate
                  {
                    title: 'Created On',
                    data: 'createdAt',
                    type: 'date', dateFormat: 'DD MMM \'YY hh:mm A',
                    renderer: createdUpdatedOnRenderer
                  },
                  {
                    title: 'Updated On',
                    data: 'updatedAt',
                    type: 'date', dateFormat: 'DD MMM \'YY hh:mm A',
                    renderer: createdUpdatedOnRenderer
                  },
                  {
                    title: 'Pickup<br> Date',
                    data: 'orders_pickupDate',
                    type: 'date', dateFormat: 'DD/MM/YYYY',
                    renderer: (...args) => pickupDateRenderer(...args, this)
                  },
                  {
                    title: 'ERP Order<br>No',
                    data: 'orderNumber',
                    renderer: (...args) => orderNumberRenderer(...args, this)
                  },
                  {
                    title: 'Route',
                    data: 'rought'
                  },
                  {
                    title:'Status',
                    data: 'internalStatus',
                    component: 'ActionPopup',
                    // renderer: actionRenderer,
                    renderer: (...args) => actionRenderer(...args, this, screen),
                    exportKey: 'internalStatus'
                  },
                  {
                    title:'Comment',
                    data: 'comment',
                    renderer: this.commentRenderer
                  },
                  {
                    title:'Client Name',
                    data: 'clientName',
                    renderer: (...args) => clientNameRenderer(...args, this, screen),
                  },
                  {
                    title:'Pickup Point',
                    data: 'pickupAreaGroup',
                    component: 'PickupPartyPopup',
                    renderer: (...args) => pickupAreaGroupRenderer(...args, this),
                    exportKey: 'pickupPartyName'
                  },
                  {
                    title:'Drop Point',
                    data: 'dropPartyName',
                    component: 'DropPartyPopup',
                    renderer: (...args) => dropAreaGroupRenderer(...args, this)
                  },
                  {
                    title:'Company',
                    data: 'companyName',
                  },
                  {
                    title:'Total<br> Weight',
                    data: 'kg',
                    type: 'numeric'
                  },
                  {
                    title:'Order<br> Details',
                    data: 'boxes',
                    component: 'QuantityPopup',
                    renderer: (...args) => orderDetailsRenderer(...args, this)
                  },
                  {
                    title:'Order Note',
                    data: 'orders_note',
                    renderer: noteRenderer
                  },
                  {
                    title:'LR No.',
                    data: 'orderDetails_lrName_lrObject',
                    renderer: (...args) => lrNumberRenderer(...args, this, screen),
                  },
                  {
                    title:'Local<br>Transport',
                    data: 'tempoPlateNum',
                    component: 'LocalVehiclePopup',
                    renderer: (...args) => localVehicleRenderer(...args, this)
                  },
                  {
                    title:'Truck<br> Details',
                    data: 'truckPlateNumber',
                    component: 'TransportVehiclePopup',
                    renderer: (...args) => transportVehicleRenderer(...args, this)
                  },
                  {
                    title:'Eway Bill No',
                    data: 'orderDetails_ewayBillNo',
                    component: 'EwayBillPopup',
                    renderer: (...args) => ewayBillRenderer(...args, this)
                  },
                  {
                    title:'Bills',
                    data: 'carryBill',
                    renderer: carryBillRenderer
                  }
                ],
                pickup_hotSettings: hotSettingsExcelOrders([120, 120, 90, 110, 100, 145, 145, 120, 125, 115, 105, 90, 120, 145, 90, 115, 115, 125, 70],
                                                            this, 'pickup_hotTableComponent', 'pickup'),
                delivery_hotSettings: hotSettingsExcelOrders([120, 120, 90, 110, 100, 145, 145, 120, 125, 115, 105, 90, 120, 145, 90, 115, 115, 125, 70],
                                                            this, 'delivery_hotTableComponent', 'delivery'),
                open_hotSettings: hotSettingsExcelOrders([120, 120, 90, 110, 100, 145, 145, 120, 125, 115, 105, 90, 120, 145, 90, 115, 115, 125, 70],
                                                            this, 'open_hotTableComponent', 'open'),
                placeOrderDrawer: false,
                manageOrderDrawer: false,
                orderId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
                currentOrderStatus: '',
                order: '',
                viewPath: '',
                confirmDialog: false,
                confirmObj: {},
                runCommentMethod: false,
                updateRecord_loader: false,
                orderNote: '',
                colsToHide: {pickup: [], delivery:[], open:[]},
                totalWeight: {pickup: 0, delivery:0, open:0},
                evaluatedWeight: {pickup: 0, delivery:0, open:0},
                numOfSelectedOrders: {pickup: 0, delivery:0, open:0},
                areaGroups: [],
                selectedAreaGroups: [],
                lrFormDialog: false,
                lrOrderId: null,
                lrId: null,
            }
        },
        computed: {
          isAdmin: function(){
            return this.$store.state.userObj.role[0].id === Constants.adminRoleId
          }
        },
        methods:{
          enableTab(){
            if(this.enableScreen[this.screen] === false){
              setTimeout(() => {
                // this.prepareComments(this.screen)
                this.updateTableSettings(this.screen)
              }, 500)
            }
            this.enableScreen[this.screen] = true;
            this.skipQuery[this.screen] = false;
          },
          onChangeColsToHide(screen){
            this[screen+'_hotSettings'].hiddenColumns = {columns: this.colsToHide[screen]};
          },
          commentRenderer(instance, td, row, col, prop, value, cellProperties) {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            let pRow = instance.toPhysicalRow(row)                               //When accessing original array
            let ordersVariable = this.screen + '_orders'

            let order = this[ordersVariable][pRow]
            let self = this
            td.ondblclick = function() {
              self.openNoteDialog(order.id)
            }
          },
          openNoteDialog(orderId){
            this.orderNote = ''
            this.$Modal.confirm({
              title: 'Enter Order Note',
              render: (h) => {
                return h('Input', {
                  props: {
                    value: this.orderNote,
                    autofocus: true,
                    placeholder: 'Enter Note...',
                    type: 'textarea'
                  },
                  on: {
                    input: (val) => {
                      this.orderNote = val;
                    }
                  }
                })
              },
              onOk: () => {
                if(this.orderNote){
                  this.insertOrderNote(orderId)
                }
              }
            })
          },
          async insertOrderNote(orderId){
            let response = await this.$apollo.mutate({
              mutation: ADD_ORDER_NOTE,
              variables: {
                orderId: orderId,
                note: this.orderNote,
                createdBy: JSON.parse(localStorage.getItem('tatkalorri')).userObj.user.id,
                lastUpdatedBy: JSON.parse(localStorage.getItem('tatkalorri')).userObj.user.id,
                createdOn: moment().format(),
                updatedOn: moment().format()
              }
            })
            if(response.data){
              this.$Message.success('Order Note added successfully!');
            }
          },
          editOrder(order){
            this.orderId = order.id;
            this.viewPath = order.internalStatus.viewPath;      //Load form based on internalStatus.viewPath
            this.order = order;
            this.currentOrderStatus = order.internalStatus.id;
            this.manageOrderDrawer = true;
          },
          refreshOrders(){
            // this.$apollo.queries.orders.refetch()
          },
          prepareSheetData(data, screen){
            let mainArr = [], totalWeight = 0;
            let mappedAreas = this.$store.state.mappedAreas;
            data.forEach(curnt => {
              curnt.obj = {
                createdAt: moment(curnt.createdAt).format('DD MMM \'YY hh:mm A'),
                updatedAt: moment(curnt.updated_at).format('DD MMM \'YY hh:mm A'),
                orders_pickupDate: moment(curnt.pickupDate, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                orderNumber: curnt.orderNumber,
                rought: roughtOfOrder(curnt),
                internalStatusId: curnt.internalstatus,
                internalStatus: curnt.internalStatus.name,
                comment: curnt.notes.length?curnt.notes[0].note:'',
                clientName: curnt.clientobject.name,
                pickupAreaGroup: curnt.orderDetails.pickupPoint.area ? mappedAreas[curnt.orderDetails.pickupPoint.area.toLowerCase()]||'' : mappedAreas[curnt.pickuppartyobject.address[0].area.toLowerCase()]||'',
                pickupPartyName: curnt.orderDetails&&curnt.orderDetails.pickupPoint&&curnt.orderDetails.pickupPoint.pickupPartyId?
                  curnt.orderDetails.pickupPoint.pickupPartyName:curnt.pickuppartyobject.name,
                dropPartyName: curnt.orderDetails&&curnt.orderDetails.dropPoint&&curnt.orderDetails.dropPoint.dropPartyId?
                  curnt.orderDetails.dropPoint.dropPartyName:curnt.droppingpartyobject.name,
                companyName: curnt.pickuppartyobject.name,
                kg: curnt.materials.kg,
                boxes: curnt.materials.boxes,
                orders_note: curnt.note?curnt.note:'-',
                orderDetails_lrName_lrObject: curnt.orderDetails&&curnt.orderDetails.lrObject?curnt.orderDetails.lrObject.lrName:'',
                tempoPlateNum: curnt.orderDetails&&curnt.orderDetails.PIckupTempo?curnt.orderDetails.PIckupTempo.tempo.platNo:
                  (curnt.orderDetails&&curnt.orderDetails.PickupTruck?curnt.orderDetails.PickupTruck.truck.platNo:''),
                truckPlateNumber: curnt.orderDetails&&curnt.orderDetails.truckOrder?curnt.orderDetails.truckOrder.truck.platNo:'',
                orderDetails_ewayBillNo: curnt.orderDetails&&curnt.orderDetails.ewayBillNo?curnt.orderDetails.ewayBillNo:'-',
                priority: curnt.priority,
                carryBill: curnt.orderDetails?.carryBill,
                bills: curnt.orderDetails?.carryBill || '-',
                lastStageUpdatedOn: curnt.lastStageUpdatedOn
              }
              mainArr.push(curnt.obj)
              totalWeight = totalWeight + Number(curnt.materials.kg)
            })

        let hotSettingsVariable = screen + '_hotSettings'
        this[hotSettingsVariable].data = mainArr
        this.updateTableSettings(screen)
        // this.prepareComments(screen)
        this.totalWeight[screen] = totalWeight
      },
      updateTableSettings(screen){
        if(screen === 'open') return;

        let hotTableComponentVariable = screen + '_hotTableComponent'
        if(!this.$refs[hotTableComponentVariable]) return
        let hotInstance = this.$refs[hotTableComponentVariable].hotInstance
        let roleId = this.$store.state.userObj.role[0].id;
        let settings = TableSettings[roleId];

        hotInstance.updateSettings({
          cells: function (row, col, prop) {
            var cellProperties = {};
            let stageId = hotInstance.getDataAtRowProp(row, 'internalStatusId')
            if(stageId && settings[stageId] && settings[stageId][prop]){
              cellProperties.readOnly = settings[stageId][prop].isReadOnly
            }

            return cellProperties;
          }
        })
      },
      async updateRecord(row, prop, newValue){
        this.updateRecord_loader = true
        let hotInstance = this.$refs[this.screen + '_hotTableComponent'].hotInstance
        let pRow = hotInstance.toPhysicalRow(row)                        //When accessing original array
        let ordersVariable = this.screen + '_orders'

        let obj = {}, id = '', record = this[ordersVariable][pRow];

        let [table, key, intermediate] = prop.split('_')                                               //eg. orderDetails_lrName_lrObject

        if(!intermediate){
          obj[key] = newValue
        }

        switch(key){
          case 'pickupDate': obj[key] = moment(newValue, 'DD/MM/YYYY').format('YYYY-MM-DD')
            break
          case 'lrName':  obj[intermediate] = record[table][intermediate]
            obj[intermediate][key] = newValue
            obj[intermediate]['islrReady'] = true
            break
        }

        switch(table){
          case 'orders': id = record.id
            break
          case 'orderDetails': id = record.orderDetails.id
            break
        }

        let response = await this.$apollo.mutate({
          mutation: generate_UPDATE_ORDER_DATA(table),
          variables: {id: id, obj: obj},
        })
        if (response.data) {
          this.updateRecord_loader = false
          this.$Message.success('Field ' +key+ ' updated successfully!')
          this.confirmDialog = false
          // this.$apollo.queries.orders.refetch()
        }
      },
      revertChange(row, prop, oldValue){
        let hotTableComponentVariable = this.screen + '_hotTableComponent'
        this.$refs[hotTableComponentVariable].hotInstance.setDataAtRowProp(row, prop, oldValue, 'revert')
        this.confirmObj = {}
        this.confirmDialog = false
      },
      prepareComments(screen){
        /* let self = this
         let hotTableComponentVariable = screen + '_hotTableComponent'
         if(!this.$refs[hotTableComponentVariable]) return
         let hotInstance = this.$refs[hotTableComponentVariable].hotInstance
         console.log('comments')

         let columnIndex = hotInstance.propToCol('clientName')         //columnIndex from prop 'clientName'
         let hotSettingsVariable = screen + '_hotSettings'
         let ordersVariable = screen + '_orders'

         this[ordersVariable].forEach(function(curnt, index){
           self[hotSettingsVariable].cell.push({row: index, col: columnIndex, comment: {value: self.getCompanyDetailString(curnt.clientobject)}})
         }) */
      },
      calculateTotalWeight(){
        let hotTableComponentVariable = this.screen + '_hotTableComponent'

        let hotInstance = this.$refs[hotTableComponentVariable].hotInstance
        let arrayOfArray = hotInstance.getSelected()
        let initialValue = 0
        let columnIndex = hotInstance.propToCol('kg')         //columnIndex from prop 'kg'
        this.evaluatedWeight[this.screen] = arrayOfArray.reduce((x, y) =>
          parseInt(x) + hotInstance.getData(y[0], columnIndex, y[2], columnIndex).reduce((a, b) =>      //columnIndex  as 'Weight' column
          parseInt(a) + parseInt(b[0]), initialValue), initialValue)

        let numOfRowsSelected = 0;
        hotInstance.getSelectedRange().forEach((curnt) => {
          numOfRowsSelected = numOfRowsSelected + (Math.abs(curnt.from.row-curnt.to.row)+1)
        })
        this.numOfSelectedOrders[this.screen] = numOfRowsSelected;
        // this.$emit('totalWeightOfSelectedOrders', this.evaluatedWeight)
      },
      getCompanyDetailString(obj){
        let str = ''
        str = 'Mobile: ' + obj.mobile + '\n'
        str = str + 'Email: ' + obj.email + '\n'
        str = str + 'Address: '
        let a = obj.address[0]
        if(a.add1) str = str + a.add1 + ', '
        if(a.add2) str = str + a.add2 + ', '
        if(a.area) str = str + a.area + ', '
        if(a.city) str = str + a.city + ', '
        if(a.state) str = str + a.state
        if(a.pincode) str = str + ' - ' + a.pincode
        return str
      },
      onChangeDate(evt){
        this.startDate = moment(evt[0], 'DD/MM/YYYY').format('YYYY-MM-DD')
        this.endDate = moment(evt[1], 'DD/MM/YYYY').format('YYYY-MM-DD')
      },
      onSearchCity(event, str){
        if(str === 'clientCity'){
          this.dealerCityFilter = '%' + this.dealerCity + '%';
          this.skip.dealerSkip = false;
        }else if(str === 'pickupCity'){
          this.pickupCityFilter = '%' + this.pickupCity + '%';
          this.skip.pickupSkip = false;
        }else if(str === 'dropCity'){
          this.droppingCityFilter = '%' + this.droppingCity + '%';
          this.skip.dropSkip = false;
        }
      },
      onSelectCity(city, str){
        if(str === 'clientCity'){
          this.selectedDealerCity = {"address":[{"city": city}]};
        }else if(str === 'pickupCity'){
          this.selectedPickupCity = {"address":[{"city": city}]};
        }else if(str === 'dropCity'){
          this.selectedDroppingCity = {"address":[{"city": city}]};
        }
      },
      onClearCity(str){
        if(str === 'clientCity'){
          this.selectedDealerCity = {"address":[]};
        }else if(str === 'pickupCity'){
          this.selectedPickupCity = {"address":[]};
        }else if(str === 'dropCity'){
          this.selectedDroppingCity = {"address":[]};
        }
      },
      startAddingOrder() {
        this.$refs['place-order-form'].skip = {dealerSkip: false, pickupSkip: false, dropSkip: false};
        this.placeOrderDrawer = true;
      },
      addLR(order){
        this.lrOrderId = order.id;
        this.lrFormDialog = true
      },
      editLR(order, lr){
        if(isLREditable(lr, order)){                     //Check Edit LR permission
          this.lrOrderId = order.id;
          this.lrId = lr.id
          this.lrFormDialog = true
        }
      },
      exportOrdersCSV(){
        let hstr = this.columns().map(col=> col.title)                                                //Column headers
        let hDatastr = this.columns().map(col=> col.exportKey?col.exportKey:col.data)                 //Data key
        let colsToHide = [...this.colsToHide[this.screen]];
        colsToHide.sort((a, b) => b - a).forEach(curnt => {                               //Remove hiddenColumn Keys
          hstr.splice(curnt, 1)
          hDatastr.splice(curnt, 1)
        });

            let str = hstr.join(',') + '\n'
            let data = JSON.parse(JSON.stringify(this[this.screen + '_hotSettings'].data));
            data.forEach(curnt => {
              Object.keys(curnt).forEach(key => {            //double quotes & replace newline character
                if(hDatastr.indexOf(key) !== -1) str = str + (key==='orderDetails_ewayBillNo'?'=':'') + '\"'+ (typeof(curnt[key])==='string'?curnt[key].replace(/\n/g, " "):(curnt[key]||'-')) + '\"' + ','
              })
              str = str + '\n'
            })
            console.log('str', str)

        str = str.replace(/<\/?[^>]+(>|$)/g,"") + '\n\n';        //Remove html tags if any

            let blob = new Blob([str], {type: 'text/plain'});
            const a = window.document.createElement('a');
            a.href = window.URL.createObjectURL(blob);
            a.download = this.screen+'_orders_' + moment().format('DD_MMM_YYYY_HH_mm') +'.csv';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          },
          exportOrdersPDF(){
            let hObj = {id: '', name: '', prompt: '', width: 50, align: "center", padding: 0}
            let headers = [
              {...hObj, name: 'orders_pickupDate', prompt:'Pickup\nDate', width:40},
              {...hObj, name: 'orderNumber', prompt:'ERP Order No'},
              {...hObj, name: 'rought', prompt:'Route'},
              {...hObj, name: 'internalStatus', prompt:'Status'},
              {...hObj, name: 'comment', prompt:'Comment'},
              {...hObj, name: 'clientName', prompt:'Client Name'},
              {...hObj, name: 'pickupPartyName', prompt:'Pickup Point'},
              {...hObj, name: 'dropPartyName', prompt:'Drop Point'},
              {...hObj, name: 'companyName', prompt:'Company'},
              {...hObj, name: 'kg', prompt:'Total\nWt' , width:35},
              {...hObj, name: 'boxes', prompt:'Order details'},
              {...hObj, name: 'orders_note', prompt:'Order Note'},
              {...hObj, name: 'orderDetails_lrName_lrObject', prompt:'LR No'},
              {...hObj, name: 'tempoPlateNum', prompt:'Local Transport'},
              {...hObj, name: 'truckPlateNumber', prompt:'Truck Details'},
              {...hObj, name: 'orderDetails_ewayBillNo', prompt:'Eway Bill No', width:45},
              {...hObj, name: 'bills', prompt:'Bills', width:25},
            ];

        let colsToHide = [...this.colsToHide[this.screen]];
        colsToHide.sort((a, b) => b - a).forEach(curnt => headers.splice(curnt, 1));

        let data = JSON.parse(JSON.stringify(this[this.screen + '_hotSettings'].data));    //get data from hotSettings.data

        let doc = new jsPDF({orientation: "landscape", format:'a2'});
        doc.table(1, 1, data, headers, { autoSize: false, fontSize: 14});
        doc.save(this.screen+'_orders_' + moment().format('DD_MMM_YYYY_HH_mm'));
      }
    },
    mounted(){
      setTimeout(() => {
        this.skipQuery.pickup = false
      }, 500)
    },
    beforeDestroy() {
      this.screenArr.forEach(screen => {
        Object.keys(this.elapsedInterval[screen]).forEach(k => clearInterval(this.elapsedInterval[screen][k]))
      })
      bus.$off();
    }
  }
</script>

<style scoped>
  /deep/  .ivu-spin-fix {
    top: 43px;
    left: 16px;
    z-index: 8;
    width: 86vw;
    height: 40vh;
  }
  /deep/ .handsontable > .ht_master{
    font-size: 14px;
  }
  /deep/ .handsontable > .ht_master > .wtHolder{
    /*width: 100% !important;*/
    width: unset !important;
    height: unset !important;
    /*max-height: unset !important;*/
  }
  .filterInput{
    width: 80%;
  }
  /deep/ .ivu-date-picker-cells  {
    font-size: 12px !important;
  }
  /deep/ .ivu-picker-panel-sidebar  {
    width:125px !important;
    margin-left:-116px !important;
  }
  .refresh-icon{
    float: right;
    margin: 9px 16px;
    font-size: 14px;
    cursor: pointer;
  }
  /deep/ .handsontable span.colHeader {
    font-size: 13px;
  }
  /deep/.handsontable td{
    vertical-align: middle !important;
    padding: 0 1px 0 1px !important;
    white-space: unset !important;
    font-size: 13px;
  }

  /deep/.handsontable th{
    background-color: #d9d9d9;
    color: #222;
    text-align: center;
    font-weight: 600;
    vertical-align: middle !important;
    white-space: nowrap !important;
    padding: 0 0px 0 0px !important;
  }
</style>
<style>
  .order-num-txt:hover {
    text-decoration: underline;
    cursor: pointer;
  }
  .green-text{
    color: green !important;
  }
  .red-text{
    color: red !important;
  }
  .red-bold-text{
    color: red !important;
    font-weight: 600;
    letter-spacing: 0.8px;
  }
  .area-group-text{
    color: blue;
  }
</style>
<style src="../../../node_modules/handsontable/dist/handsontable.full.css"></style>
